import {
  Card,
  Col,
  DatePicker,
  Input,
  message,
  Modal,
  Row,
  Table,
  Tag,
} from "antd";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { BaseUrl, AssesmentUrl } from "../../../Constants/Constants";
import { Select, Checkbox, Button, Popover } from "antd";
import "./ScoreUsers.css";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

const { RangePicker } = DatePicker;

const ScoreUsers = () => {
  const [userData, setUserData] = useState([]);
  // const [selectedTeam, setSelectedTeam] = useState('d8d3b0cb-02f4-4fe2-9ef6-afc0a34ef8c3');
  const [selectedTeam, setSelectedTeam] = useState("");
  const [teamOption, setTeamOption] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectLoading, setSelectLoading] = useState(false);
  const [allData, setAllData] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [sortbyScore, setSortByScore] = useState("");
  const [searchCourse, setSearchCourse] = useState("");
  const [searchEmployee, setSearchEmployee] = useState("");
  const [clearTableData, setClearTableData] = useState([]);
  const [previousSelectedRowKeys, setPreviousSelectedRowKeys] = useState([]);
  const [dateRange, setDateRange] = useState([]);
  const [betweenDates, setBetweenDates] = useState([]);
  const [viewReason, setViewReason] = useState([]);
  const [viewReasonModal, setViewReasonModal] = useState(false);
  const [allSelectedRecords, setAllSelectedRecords] = useState([]);

  const navigate = useNavigate();

  const handleMainCheckboxChange = (e) => {
    // If the main checkbox is checked, set the selected row keys to all row keys
    // If the main checkbox is unchecked, clear the selected row keys
    setSelectedRowKeys(
      e.target.checked ? dataSource.map((item) => item.key) : [],
    );
  };
  // const rowSelection = {
  //   selectedRowKeys,
  //   onChange: (selectedRowKeys, selectedRows) => {
  //     setSelectedRowKeys(selectedRowKeys);
  //   },
  // };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);

    // Get full data for newly selected keys
    const currentlySelected = clearTableData.filter((item) =>
      newSelectedRowKeys.includes(item.key),
    );

    // Keep previously selected records that are NOT in current table
    const previouslySelected = allSelectedRecords.filter(
      (record) => !clearTableData.some((item) => item.key === record.key),
    );

    // Merge: previous + current
    setAllSelectedRecords([...previouslySelected, ...currentlySelected]);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const handleSortChange = (value) => {
    if (value === "score") {
      setSortByScore(true);
    } else {
      setSortByScore(false);
    }
  };

  const sortedDataSource = sortbyScore
    ? [...allData].sort((a, b) => b.score - a.score)
    : allData;

  const dataSource = allData?.map((data, index) => ({
    key: index + 1,
    serial: index + 1,
    username: data.username,
    email: data.email,
    no_of_question: data.no_of_question,
    score: `${data.max_score}/${data.no_of_question}`,
    course_title: data.course_title,
    date: data.created_dt,
    assessment_attempt_count: data.assessment_attempt_count,
  }));

  const hasSelected = selectedRowKeys.length > 0;

  const getDatesBetween = (startDate, endDate) => {
    let dates = [];
    let currentDate = moment(startDate);
    const end = moment(endDate);

    while (currentDate <= end) {
      dates.push(currentDate.format("YYYY-MM-DD"));
      currentDate = currentDate.add(1, "days");
    }

    return dates;
  };

  const handleDateRangeChange = (dates, dateString) => {
    const [startDate, endDate] = dateString;
    const datesBetween = getDatesBetween(startDate, endDate);

    setBetweenDates(datesBetween);
  };

  const filterData = () => {
    let filteredData = [...allData];

    // Filter by course
    if (searchCourse !== "") {
      filteredData = filteredData.filter((data) =>
        data.course_title?.toLowerCase().includes(searchCourse.toLowerCase()),
      );
    }

    // Filter by user name
    if (searchEmployee !== "") {
      filteredData = filteredData.filter((data) =>
        data.username?.toLowerCase().includes(searchEmployee.toLowerCase()),
      );
    }

    if (betweenDates.length != 0) {
      const dateOfDates = [
        "2024-06-11",
        "2024-06-12",
        "2024-06-13",
        "2024-06-14",
        "2024-06-15",
        "2024-06-16",
        "2024-06-17",
        "2024-06-18",
        "2024-06-19",
        "2024-06-20",
        "2024-06-21",
        "2024-06-22",
        "2024-06-23",
        "2024-06-24",
        "2024-06-25",
        "2024-06-26",
        "2024-06-27",
        "2024-06-28",
        "2024-06-29",
      ];
      filteredData = filteredData.filter((item) => {
        let formattedDate = item.created_dt.split("T")[0];
        return betweenDates.includes(formattedDate);
      });
    }

    // Map to format required by clearTableData
    const formattedData = filteredData.map((data, index) => {
      let time = data.created_dt.split("T")[1];
      let correctedTime = time.split(".")[0];
      let onlyDate = data.created_dt.split("T")[0];
      let formattedDateStep = onlyDate.split("-");
      let formattedDate = `${formattedDateStep[2]}-${formattedDateStep[1]}-${formattedDateStep[0]}`;
      let createdAtFormattedDate = data.created_dt.replace("T", " ");
      const uniqueKey = `${data.email}-${data.course_title}-${data.created_dt}`;
      return {
        key: uniqueKey,
        serial: index + 1,
        username: data.username,
        email: data.email,
        no_of_question: data.no_of_question,
        score: `${data.score}/${data.no_of_question}`,
        course_title: data.course_title,
        date: formattedDate + " " + correctedTime,
        created_dt: createdAtFormattedDate,
        user_id: data.user_id,
        assessment_id: data.assessment_id,
        assessment_type: data.assessment_type,
        assessment_attempt_count: data.assessment_attempt_count,
      };
    });

    // Restore checkboxes for previously selected items
    const keysInCurrentView = formattedData.map((item) => item.key);
    const selectedKeysStillVisible = allSelectedRecords
      .filter((record) => keysInCurrentView.includes(record.key))
      .map((record) => record.key);

    setSelectedRowKeys(selectedKeysStillVisible);

    setClearTableData(formattedData);
  };

  useEffect(() => {
    filterData();
  }, [searchCourse, allData, betweenDates, searchEmployee]);

  //  clears selections when filters change
  // useEffect(() => {
  //   setSelectedRowKeys([]);
  // }, [searchEmployee, searchCourse, betweenDates]);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${AssesmentUrl}all_score`, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((res) => {
        setAllData(res.data.score);
      })
      .catch((err) => {
        console.log("errr", err);
      })
      .finally(() => {
        setLoading(false); // ← ADD THIS
      });
  }, []);

  const columns = [
    // {
    //   title: 'S.No',
    //   dataIndex: 'key',
    //   key: 'key',
    //   align: 'center',
    // },
    {
      title: "Assessment Date Time",
      dataIndex: "date",
      key: "date",
      align: "center",
      sorter: (a, b) => {
        const dateA = moment(a.date, "DD-MM-YYYY HH:mm:ss");
        const dateB = moment(b.date, "DD-MM-YYYY HH:mm:ss");
        return dateA - dateB;
      },
      width: 130,
    },
    {
      title: "Employee Name",
      dataIndex: "username",
      key: "username",
      align: "left",
      width: 150,
    },
    {
      title: "Email ID",
      dataIndex: "email",
      key: "email",
      align: "left",
      width: 250,
    },
    {
      title: "Course Title",
      dataIndex: "course_title",
      key: "course_title",
      align: "center",
      width: 150,
    },
    {
      title: "Attempt count",
      dataIndex: "assessment_attempt_count",
      key: "assessment_attempt_count",
      align: "center",
      width: 100,
    },
    {
      title: "Score",
      dataIndex: "score",
      key: "score",
      align: "center",
      sorter: (a, b) => {
        // Extract numerical values from the score strings
        const [aMax, aTotal] = a.score.split("/").map(Number);
        const [bMax, bTotal] = b.score.split("/").map(Number);

        // Calculate the score as a fraction or percentage
        const aScore = aMax / aTotal;
        const bScore = bMax / bTotal;

        // Compare the calculated scores
        return aScore - bScore;
      },
      width: 100,
    },
    {
      title: "View Description",
      dataIndex: "view_reasons",
      render: (_, record) => {
        return (
          <>
            {record.assessment_type === "mcq with description" ? (
              <VisibilityIcon onClick={() => handleViewRecord(record)} />
            ) : (
              <>
                <Popover content="No description available">
                  <VisibilityOffIcon />
                </Popover>
              </>
            )}
          </>
        );
      },
      width: 100,
    },
  ];

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${BaseUrl}teams`, { withCredentials: true })
      .then((res) => {
        let teams = res.data.map((item) => {
          let teamsObj = {
            value: item.team_id,
            label: item.Team_name,
          };
          return teamsObj;
        });
        setTeamOption(teams);
      })
      .catch((err) => {
        console.log(err.message);
      })

      .finally(() => {
        setLoading(false);
      });
  }, []);

  // useEffect(() => {
  //   if (selectedRowKeys.length != 0) {
  //     ///////====================Last working code without removing the unchecking the row data=========/////////

  //     const mergedSelectedRowKeys = Array.from(
  //       new Set([...previousSelectedRowKeys, ...selectedRowKeys]),
  //     );

  //     let filteredUsers = mergedSelectedRowKeys.map((i) =>
  //       clearTableData.find((item) => item.key === i),
  //     );
  //     // Ensure each filtered user has a unique key
  //     filteredUsers = filteredUsers.map((user, index) => {
  //       return {
  //         date: user.date,
  //         username: user.username,
  //         email: user.email,
  //         courseTitile: user.course_title,
  //         noOfQuestions: user.no_of_question,
  //         score: user.score,
  //       };
  //     });

  //     setUserData(filteredUsers);
  //     // Update the previous selected row keys
  //     setPreviousSelectedRowKeys(mergedSelectedRowKeys);
  //   } else {
  //     let users = clearTableData.map((item) => {
  //       let correctedDate = item.date.split("T")[0];
  //       let userObj = {
  //         // key: item.user_id,
  //         date: item.date,
  //         username: item.username,
  //         email: item.email,
  //         courseTitile: item.course_title,
  //         noOfQuestions: item.no_of_question,
  //         score: item.score,
  //         // team: item.team_id.Team_name
  //       };
  //       return userObj;
  //     });

  //     setUserData(users);
  //     setPreviousSelectedRowKeys([]);
  //   }
  // }, [selectedRowKeys, clearTableData.length]);

  useEffect(() => {
    if (allSelectedRecords.length > 0) {
      // Use allSelectedRecords directly - it already has all selected data!
      const formattedUsers = allSelectedRecords.map((user) => ({
        date: user.date,
        username: user.username,
        email: user.email,
        courseTitile: user.course_title,
        Assessment_name: user.Assessment_name, // For CourseCompletion
        // noOfQuestions: user.no_of_question,  // For ScoreUsers
        score: user.score,
        status: "Completed", // For CourseCompletion only
      }));

      setUserData(formattedUsers);
    } else {
      // No selections - download all current table data
      const users = clearTableData.map((item) => ({
        date: item.date,
        username: item.username,
        email: item.email,
        courseTitile: item.course_title,
        Assessment_name: item.Assessment_name, // For CourseCompletion
        // noOfQuestions: item.no_of_question,  // For ScoreUsers
        score: item.score,
        status: "Completed", // For CourseCompletion only
      }));

      setUserData(users);
    }
  }, [allSelectedRecords, clearTableData]);
  const now = new Date();

  const padZero = (num) => num.toString().padStart(2, "0");

  const day = padZero(now.getDate());
  const month = padZero(now.getMonth() + 1); // getMonth() returns 0-based month
  const year = now.getFullYear().toString().slice(-2); // get last two digits of the year
  const hours = padZero(now.getHours());
  const minutes = padZero(now.getMinutes());

  let formattedCurrentTime = `${day}-${month}-${year}(${hours}.${minutes})`;

  const handleDownload = () => {
    const columnNames = [
      "Assessment Date Time",
      "Employee Name",
      "Email ID",
      "Course Title",
      "No of Assessment Questions",
      "Score",
    ];
    // const columnNames = ['Course Title', 'Username', 'Email', 'No of Questions', 'Score', 'Date'];
    // const csvContent = "data:text/csv;charset=utf-8," +
    //   userData.map(row => Object.values(row).join(",")).join("\n");
    const csvContent = `data:text/csv;charset=utf-8,${[columnNames.join(",")].concat(userData.map((row) => Object.values(row).join(","))).join("\n")}`;
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `Reports ${formattedCurrentTime}.csv`);
    document.body.appendChild(link);
    link.click();
  };

  const handleRoute = (e) => {
    navigate(e);
  };

  const handleSelectedRowToDownload = () => {
    const allCurrentKeys = clearTableData.map((row) => row.key);

    if (selectedRowKeys.length === clearTableData.length) {
      // Deselect all in current view
      const keysToRemove = new Set(allCurrentKeys);
      const remaining = allSelectedRecords.filter(
        (r) => !keysToRemove.has(r.key),
      );
      setAllSelectedRecords(remaining);
      setSelectedRowKeys([]);
    } else {
      // Select all in current view
      const previousRecords = allSelectedRecords.filter(
        (r) => !clearTableData.some((item) => item.key === r.key),
      );
      setAllSelectedRecords([...previousRecords, ...clearTableData]);
      setSelectedRowKeys(allCurrentKeys);
    }
  };

  const handleViewRecord = (record) => {
    let body = {
      created_dt: record.created_dt,
      assessment_id: record.assessment_id,
      user_id: record.user_id,
    };

    setLoading(true);
    axios
      .post(`${AssesmentUrl}user_description_report`, body, {
        withCredentials: true,
      })
      .then((res) => {
        if (res.data.status === 200) {
          setViewReason(res.data.description_response);
          setViewReasonModal(true);
        } else {
          message.error("Failed to view the reasons");
        }
      })
      .catch((err) => {
        message.error(err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const reasonModalCancel = () => {
    setViewReasonModal(false);
  };

  return (
    <div className="scoresMainDiv">
      <Modal
        className="viewReasonModalClass"
        title="Justified Reasons"
        open={viewReasonModal}
        onCancel={reasonModalCancel}
        footer={false}
      >
        {viewReason.map((item, index) => (
          <Card
            className={
              item.description_score == 0
                ? "red-viewReasonCard"
                : "green-viewReasonCard"
            }
            key={index}
          >
            <b
              className={`${item.description_score == 0 ? "red" : "green"}descriptionScoreClass`}
            >
              Score for description : {item.description_score}
            </b>
            <p>
              <b>Question : </b>
              {item.question}
            </p>
            <div className="wholeDescriptionClass">
              <div className="userDescClass">
                <b style={{ margin: 0 }}>User Description</b>
                <p>{item.user_description}</p>
              </div>
              <div className="correctDescClass">
                <b style={{ margin: 0 }}>Correct Description</b>
                <p>{item.correct_description}</p>
              </div>
            </div>
          </Card>
        ))}
      </Modal>
      <div className="reportsSideHeading">
        <h4
          className="nonActiveHeading"
          onClick={() => handleRoute("/coursesactivityreports")}
        >
          Course Activity Report
        </h4>
        <h4
          className="nonActiveHeading"
          onClick={() => handleRoute("/trainingreports")}
        >
          Training Report
        </h4>
        <h4
          className="nonActiveHeading"
          onClick={() => handleRoute("/courseParts")}
        >
          Course Part Report
        </h4>
        {/* <h4 className='nonActiveHeading' style={{ cursor: 'not-allowed' }} 
        // onClick={() => handleRoute('/trainingnoncompletionreports')} 
        >Training Non-compliance Report</h4>
        <h4 className='nonActiveHeading' style={{ cursor: 'not-allowed' }}
        //  onClick={() => handleRoute('/userreports')}
        >User Report</h4> */}
        <h4 className="activeHeading" onClick={() => handleRoute("/reports")}>
          Course Report
        </h4>
      </div>
      <h2>Reports</h2>
      <div>
        <Row
          gutter={12}
          align="middle"
          justify="space-between"
          style={{ marginBottom: 10 }}
        >
          {/* Left side */}
          <Col>
            <RangePicker
              style={{ height: 36 }}
              onChange={handleDateRangeChange}
            />
          </Col>

          <Col>
            <Input
              placeholder="Search by Course"
              style={{ height: 36, width: 200 }}
              onChange={(e) => setSearchCourse(e.target.value)}
            />
          </Col>

          <Col>
            <Input
              placeholder="Search by Employee Name"
              style={{ height: 36, width: 200 }}
              onChange={(e) => setSearchEmployee(e.target.value)}
            />
          </Col>

          {/* Right side */}
          <Col>
            <Button
              onClick={handleSelectedRowToDownload}
              disabled={loading || clearTableData.length === 0}
              style={{ height: 36 }}
            >
              {loading
                ? "Loading..."
                : selectedRowKeys.length === clearTableData.length &&
                    clearTableData.length > 0
                  ? `Deselect All (${clearTableData.length})`
                  : `Select All (${clearTableData.length})`}
            </Button>
          </Col>

          <Col>
            <Button
              type="primary"
              style={{ height: 36 }}
              onClick={handleDownload}
            >
              Download Report
            </Button>
          </Col>
        </Row>
        {/* This row shows the clarity on selected & persisted data */}
        <Row
          gutter={12}
          align="left"
          justify="start"
          style={{ marginBottom: 10 }}
        >
          {allSelectedRecords.length > 0 && (
            <Col>
              <Button
                danger
                onClick={() => {
                  setSelectedRowKeys([]);
                  setAllSelectedRecords([]);
                }}
              >
                Clear All ({allSelectedRecords.length})
              </Button>
            </Col>
          )}
          {selectedRowKeys.length > 0 && (
            <Col>
              <Tag color="blue">
                {selectedRowKeys.length} selected
                {allSelectedRecords.length !== selectedRowKeys.length &&
                  ` (${allSelectedRecords.length} total)`}
              </Tag>
            </Col>
          )}
        </Row>
        <Table
          // dataSource={userData}
          loading={loading}
          dataSource={clearTableData}
          columns={columns}
          pagination={{
            position: ["bottomCenter"],
            showSizeChanger: false,
          }}
          rowSelection={rowSelection}
          // columns={userColumn}
        />
      </div>
    </div>
  );
};

export default ScoreUsers;
